import React from "react";
import NotificationIcon from "../../assets/notification-icon.svg";
import { useAppSelector } from "../../store/hooks";
const CustomHeader = ({ headerLabels = [], activeLabel, setActiveLabel, onHeaderNavigation }) => {
  const { isPartsURL, isAccessoriesURL } = useAppSelector((state) => state.domain);
  const tabStyle = {
    base: {
      background: "none",
      border: "none",
      outline: "none",
      cursor: "pointer",
      fontSize: "15px",
      fontWeight: 400,
      color: "#57606A", // Gray text
      padding: "5px 7px",
      borderBottom: "2px solid transparent",
      transition: "color 0.3s ease, border-bottom 0.3s ease",
    },
    active: {
      fontWeight: 500,
      color: isPartsURL ? "var(--primary-color-parts)" : isAccessoriesURL ? "var(--primary-color-acc)" : "var(--primary-color-mobile)",
      borderBottom: isPartsURL ? "2px solid var(--primary-color-parts)" : isAccessoriesURL ? "2px solid var(--primary-color-acc)" : "2px solid var(--primary-color-mobile)",
    },
  };

  return (
    <header className="bg-white header-custom">
      <div className="d-flex justify-content-between align-items-center">
        
        {/* Tabs on the left (unchanged styles) */}
        <div className="d-flex flex-wrap gap-2 header-tabs-container">
          {headerLabels.map((item) => {
            const isActive = activeLabel === item.value;
            return (
              <button
                key={item.value}
                onClick={() => {
                  if (onHeaderNavigation) {
                    onHeaderNavigation(item.value);
                  } else {
                    setActiveLabel(item.value);
                  }
                }}
                style={{
                  ...tabStyle.base,
                  ...(isActive ? tabStyle.active : {}),
                }}
              >
                {item.label}
              </button>
            );
          })}
        </div>

        {/* Bell on the right (same as first header) */}
        <div
          className="d-flex align-items-center gap-3"
          style={{
            border: "1px solid #EAEEF2",
            borderRadius: "5px",
            padding: "0.3rem",
            background: "#FAFBFF",
          }}
        >
          <button className="border-0 bg-transparent">
            <img src={NotificationIcon} alt="Notification" className="text-sidebar-normal" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default CustomHeader;
